import { InputProps } from 'react-select';
import { BaseOption } from 'ui/selectv2/types';
import { MultiSelectInput } from 'ui/selectv2/MultiSelectInput';
import { getOnKeyDownForInput } from './utils/getOnKeyDownForInput';

type Props = InputProps<BaseOption<string>> & {
  onMultiSelectUpdate: () => void;
  isMenuOpen: boolean;
  search?: string;
  setSearch?: (val: string) => void;
};

export const DATA_TEST = {
  input: 'qb-multivalue-input',
};

export const CustomMultiValueInput = ({
  onMultiSelectUpdate,
  isMenuOpen,
  search,
  setSearch,
  ...props
}: Props) => {
  const onKeyDownForInput = getOnKeyDownForInput(onMultiSelectUpdate, isMenuOpen);
  return (
    <MultiSelectInput
      {...props}
      data-test={DATA_TEST.input}
      autoFocus
      onKeyDown={onKeyDownForInput}
      aria-placeholder="Select a value..."
    />
  );
};
